module.exports = __webpack_public_path__ + "media/images/sp/plans/reason_01_after@2x-9b41fb12c5da36050af1e83cf8bd1337.webp";